// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CkegJ","importantInfo":"styles_importantInfo__pDF2h"};